export default __webpack_public_path__ + "static/media/fa-solid-900.cd8a6b13.svg";